import { Injectable } from '@angular/core';
import { NotificationService } from 'src/app/_services/notification.service';
import { ErrorMessageService } from '../errorMessageDialog/services/errorMessage.service';
import { ErrorMessage } from '../errorMessageDialog/models/errorMessage.model';

@Injectable({
    providedIn: 'root'
})

export class ErrorResponseService {

    constructor(
        private errorMessageService: ErrorMessageService,
        private notificationService: NotificationService
    ) { }

    notify(error, errorMessage = 'Došlo je do greške na serveru'): void {
        console.log(error);
        const errorMessages = this.initErrorMessage({ 
            error, 
            errorMessages: [errorMessage]
        });
        this.notificationService.error(
            errorMessages ? errorMessages.join(', ') : '');
    }

    private initErrorMessage({ error, errorMessages }): string[] {
        if (typeof (error.error) === 'string' && error.error?.length < 100)
            errorMessages = [error.error];
        if (Array.isArray(error.error) && error.error?.length > 0)
            errorMessages = error.error;
        return errorMessages;
    }

    openDialog(error, message = 'Došlo je do greške na serveru'): void {
        console.log(error);
        this.errorMessageService.displayDialog({
            errorMessage: this._errorMessageResponse({ 
                error, 
                messages: [message]
            })
        });
    }

    private _errorMessageResponse({ error, messages }): ErrorMessage {
        return {
            header: `Serverska greška sa statusom ${error?.status}`,
            errorMessages: this._dialogErrorMessage({ error, messages })
        };
    }

    private _dialogErrorMessage({ error, messages }): string[] {
        if (typeof (error.error) === 'string')
            messages = [error.error];
        if (Array.isArray(error.error) && error.error?.length > 0)
            messages = error.error; // ovo je niz (error.error)
        return messages;
    }
}
